import { render, staticRenderFns } from "./AbsenceUnjustifiedDayLegend.vue?vue&type=template&id=673ee294&"
import script from "./AbsenceUnjustifiedDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceUnjustifiedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673ee294')) {
      api.createRecord('673ee294', component.options)
    } else {
      api.reload('673ee294', component.options)
    }
    module.hot.accept("./AbsenceUnjustifiedDayLegend.vue?vue&type=template&id=673ee294&", function () {
      api.rerender('673ee294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/AbsenceUnjustifiedDayLegend.vue"
export default component.exports